import api from "shared/api";
import { InvoiceRaw, AccessLogUserRaw } from "./models";

const prefix = "api/invoices";

export const getInvoicesForCurrentUser = async (): Promise<InvoiceRaw[]> => {
  const res = await api().get<InvoiceRaw[]>(`${prefix}/current-user`);
  return res.data;
};

export const getAccessLogs = async (): Promise<AccessLogUserRaw[]> => {
  const res = await api().get<AccessLogUserRaw[]>(`${prefix}/access-logs`);
  return res.data;
};
